import { ReactComponent as FileUploadIcon } from '@/assets/img/v2/file-upload-icon.svg';
import './FileUploader.scss';
import { useRef, useState } from 'react';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
import { ReactComponent as EditIcon } from '@/assets/img/v2/edit-pencil-icon.svg';
import { showNotification } from '@/utils/notificationUtils';
import { useTranslation } from 'react-i18next';
type FileUploaderProps = {
  onUpload: (formData: FormData) => void;
  url?: string;
  isUploading: boolean;
};
export const FileUploader = ({ onUpload, url, isUploading }: FileUploaderProps) => {
  const fileInputRef = useRef(null);
  const { t, i18n } = useTranslation();
  const onFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files as FileList;
    //setImageUrl('');
    UploadProfilePic(selectedFiles?.[0]);
  };

  const UploadProfilePic = async (selectedFiles: any) => {
    if (selectedFiles.size > 1500000) {
      showNotification({
        type: 'info',
        title: t('Uploaded image should be less than 1.5 mb .'),
      });
      return false;
    }
    if (selectedFiles) {
      const formData = new FormData();
      formData.append('file', selectedFiles);
      onUpload(formData);
    }
  };

  const onUploadImageHandler = () => {
    if (!isUploading && fileInputRef && fileInputRef.current) {
      (fileInputRef.current as any).click();
    }
  };
  return (
    <div className="file-uploader">
      <div className="image-section" onClick={onUploadImageHandler}>
        {url ? (
          <span className="image-holder">
            <img src={url} /> {!isUploading && <EditIcon className="edit-icon" />}
          </span>
        ) : (
          <FileUploadIcon />
        )}
        {isUploading && <Lottie className="loader-animation" animationData={progressAnimation} />}

        <input
          type="file"
          onChange={onFileSelect}
          ref={fileInputRef}
          hidden
          placeholder="Attribute name"
        />
      </div>
      <p>
        {t('Upload in')} <b>{t('JPG')}</b> {t('or')} <b>{t('PNG')}</b> {t('format')} <br />
        {t('maximum')} <b>{t('1.5MB')}</b> {t('in')} <b>1:1</b> {t('ratio')}
      </p>
    </div>
  );
};
